/******************************************************************************************
 *	Demo Mode Service
 ******************************************************************************************/
(function() {
  

  angular.module('rcServices.demoMode', []).service(
    'DemoMode',
    /* @ngInject */
    function($log, $injector, $q, _, COUNTRY_LIST_CACHE_ID, modelCache) {
      //Demo Mode State (on / off)
      var enabled = false;
      this.isEnabled = function() {
        return enabled;
      };
      this.isMockEnabled = function() {
        return this.isEnabled() && this.useMockData();
      };
      this.useMockData = function() {
        //Avoid circular dependencies
        var feature = $injector.get('feature');
        return feature.isEnabled('use_mock_data');
      };
      this.enable = function() {
        //Avoid circular dependencies
        var MiniJil = $injector.get('MiniJil');
        var Auth = $injector.get('Auth');
        var User = $injector.get('User');

        var deferred = $q.defer();

        //Initialize MiniJIL, then get auth data
        MiniJil.initialize(this.useMockData())
          .then(function() {
            MiniJil.getDemoUser()
              .then(function(responseData) {
                enabled = true;
                $log.info('%cDemo Mode :: ENABLED', 'font-weight:bold;color:#009966;');

                //Set user
                User.set(
                  responseData.userId,
                  responseData.first_name,
                  responseData.last_name,
                  responseData.email
                );

                //Set user roles
                User.setRoles(responseData.roles);

                // Cache country data
                var $http = $injector.get('$http');
                var $q = $injector.get('$q');
                var CountryList = $injector.get('CountryList');
                var countryList = new CountryList();
                countryList.$promise = $q.resolve(countryList);
                $http({
                  method: 'GET',
                  url: '/demo-data/countries.json'
                })
                  .then(function(response) {
                    countryList.items = _.get(response, 'data.countries');
                    modelCache.put(COUNTRY_LIST_CACHE_ID, countryList);
                  })
                  .catch(function() {
                    modelCache.put(COUNTRY_LIST_CACHE_ID, countryList);
                  });

                //Login demo user
                Auth.loginDemoUser(responseData.ims.accessToken);

                deferred.resolve();
              })
              .catch(deferred.reject);
          })
          .catch(deferred.reject);

        return deferred.promise;
      };

      this.disable = function() {
        //Avoid circular dependecies
        var Auth = $injector.get('Auth');

        enabled = false;
        $log.info('%cDemo Mode :: DISABLED', 'font-weight:bold;color:#009966;');

        Auth.logout();
      };
    }
  );
})();
